/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BaseWriteConfigObject } from './BaseWriteConfigObject';
import {
    BaseWriteConfigObjectFromJSON,
    BaseWriteConfigObjectFromJSONTyped,
    BaseWriteConfigObjectToJSON,
} from './BaseWriteConfigObject';

/**
 * 
 * @export
 * @interface BaseWriteConfig
 */
export interface BaseWriteConfig {
    /**
     * This is a map of object names to their configuration.
     * @type {{ [key: string]: BaseWriteConfigObject; }}
     * @memberof BaseWriteConfig
     */
    objects?: { [key: string]: BaseWriteConfigObject; };
}

/**
 * Check if a given object implements the BaseWriteConfig interface.
 */
export function instanceOfBaseWriteConfig(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BaseWriteConfigFromJSON(json: any): BaseWriteConfig {
    return BaseWriteConfigFromJSONTyped(json, false);
}

export function BaseWriteConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaseWriteConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objects': !exists(json, 'objects') ? undefined : (mapValues(json['objects'], BaseWriteConfigObjectFromJSON)),
    };
}

export function BaseWriteConfigToJSON(value?: BaseWriteConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'objects': value.objects === undefined ? undefined : (mapValues(value.objects, BaseWriteConfigObjectToJSON)),
    };
}

